import { render, staticRenderFns } from "./PWStripe.vue?vue&type=template&id=56d878ec&scoped=true&"
import script from "./PWStripe.vue?vue&type=script&lang=js&"
export * from "./PWStripe.vue?vue&type=script&lang=js&"
import style0 from "./PWStripe.vue?vue&type=style&index=0&id=56d878ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d878ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VSpacer})
